var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-item",class:_vm.eventClass,style:(_vm.eventItemStyle)},[_c('div',{staticClass:"event-item__text",class:_vm.textClass},[(_vm.iconClass)?_c('i',{class:_vm.iconClass}):_c('span',[_vm._v(_vm._s(_vm.index))])]),(_vm.point.is_moved)?_c('div',{staticClass:"event-item__moved-indicator"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }